var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_message-question",
    "data-name": "vuesax/bulk/message-question",
    transform: "translate(-620 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-question"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(620 252)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M15,16H11L6.55,18.96A1,1,0,0,1,5,18.13V16a4.724,4.724,0,0,1-5-5V5A4.724,4.724,0,0,1,5,0H15a4.724,4.724,0,0,1,5,5v6A4.724,4.724,0,0,1,15,16Z",
    transform: "translate(622 254.43)",
    fill: "#908fa2",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2.41,6a.755.755,0,0,1-.75-.75V5.04A2.327,2.327,0,0,1,2.83,3.09c.37-.25.49-.42.49-.68a.91.91,0,1,0-1.82,0,.755.755,0,0,1-.75.75A.755.755,0,0,1,0,2.41a2.41,2.41,0,1,1,4.82,0A2.294,2.294,0,0,1,3.67,4.33c-.39.26-.51.43-.51.71v.21A.749.749,0,0,1,2.41,6Z",
    transform: "translate(629.59 258.11)",
    fill: "#908fa2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.75,1.5A.75.75,0,1,1,1.5.75.749.749,0,0,1,.75,1.5Z",
    transform: "translate(631.25 265.1)",
    fill: "#908fa2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.458b6116b693ee0a16a7d0f5a23b009e.svg";
export { ForwardRef as ReactComponent };